// extracted by mini-css-extract-plugin
export var banner = "_dg-0";
export var closeButton = "_dg-2";
export var greenCheckmark = "_dg-3";
export var hereLink = "_dg-4";
export var titleIcon = "_dg-1";